import { Box } from "@chakra-ui/layout";
import { FC, forwardRef, Ref } from "react";

type Props = {
  isActive: boolean;
  ref: Ref<HTMLDivElement>;
}

export const RowChildDropzone:FC<Props> = forwardRef(
  ({ isActive }, ref: Ref<HTMLDivElement>
) => (
  <Box
    opacity={isActive ? 1 : 0}
    layerStyle={[ 'with-transition' ]}
    ref={ref}
    height="100%"
    border="1px dashed"
    borderRadius="4px"
    borderColor="brand.500"
    overflow="hidden"
  />
));

RowChildDropzone.displayName = "RowChildDropZone";
